import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import DashboardLayout from "./components/DashboardLayout";
import NewsPage from "./pages/NewsPage";
import EventsPage from "./pages/EventPage";
import HeaderSection from "./components/HeaderSection";
import TopSection from "./components/TopSection";
import Navbar from "./components/Navbar";
import ImageSection from "./components/ImageSection";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import GrampanchayatInfo from "./components/GrampanchayatInfo";
import ProgramsPage from "./components/ProgramPage";
import ShasanNirnay from "./components/ShasanNirnay";
import AdhisuchanaPage from "./components/Adisuchana";
import TakrarNivaranPortal from "./components/TakrarNivaranPortal";
import DhrushtiAniDhyey from "./components/DrushtiAniDhyey";
import RightToInformation from "./components/RightToInformation";
import CreateNews from "./pages/CreateNews";
import ReadNews from "./pages/ReadNews";
import UpdateNews from "./pages/UpdateNews";
import CreateBodyMember from "./pages/CreateBodyMember";
import Shala from "./components/Shala";
import Vyayamshala from "./pages/Vyayamshala";
import Vachanalay from "./pages/Vachanalay";
import Temples from "./pages/Temples";
import GrampanchayatSuchana from "./components/GrampanchayatSuchana";
import CreatePrograms from "./pages/CreatePrograms";
import ReadPrograms from "./pages/ReadPrograms";
import KarBharna from "./pages/KarBharna";

function LayoutWrapper({ children }) {
  const location = useLocation();

  // Hide top sections for /dashboard routes
  const hideForDashboard = location.pathname.startsWith("/dashboard");

  return (
    <>
      {!hideForDashboard && (
        <>
          <TopSection />
          <HeaderSection />
          <Navbar />
          <ImageSection />
        </>
      )}

      {children}

      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/grampanchayat-suchana" element={<GrampanchayatSuchana />} />
          <Route path="/grampanchayatinfo" element={<GrampanchayatInfo />} />
          <Route path="/shala" element={<Shala />} />
          <Route path="/vyayam-shala" element={<Vyayamshala />} />
          <Route path="/vachanalay" element={<Vachanalay />} />
          <Route path="/temples" element={< Temples/>} />
          <Route path="/programs/programs" element={<ProgramsPage />} />
          <Route path="/shasannirnay" element={<ShasanNirnay />} />
          <Route path="/adhisuchana" element={<AdhisuchanaPage />} />
          <Route path="/takrarnivaranportal" element={<TakrarNivaranPortal />} />
          <Route path="/drushtianidhyey" element={<DhrushtiAniDhyey />} />
          <Route path="/rti" element={<RightToInformation />} />
          <Route path="/karbharna" element={<KarBharna />} />

          {/* Dashboard parent */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route path="news" element={<NewsPage />} />
            <Route path="news/create-news" element={<CreateNews />} />
            <Route path="news/read-news" element={<ReadNews />} />
            <Route path="news/update-news/:id" element={<UpdateNews />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="programs/create-programs" element={<CreatePrograms />} />
            <Route path="programs/read-programs" element={<ReadPrograms />} />
            <Route path="body-members/create-body-members" element={<CreateBodyMember />} />
          </Route>
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;